import Vue from "vue";
import Router from "vue-router";
import module from "./module";
import Index from "@views/home/Index";
import Search from "@views/shop/GoodSearch";
import Category from "@views/shop/GoodsClass";
import ShoppingCart from "@views/shop/ShoppingCart";
import IntegralShoppingCart from "@views/shop/integral/list";
import activityArea from "@views/activity/activityArea";
import LuckyAward from "@views/activity/LuckyAward";
import Turntable from "@views/activity/Turntable";
import Club from "@views/activity/Club";
import ClubLottery from "@views/activity/ClubLottery";

import GoodsList from "@views/shop/GoodsList";
import NotDefined from "@views/NotDefined";
import $store from "../store";
import toLogin from "@libs/login";
import Loading from "@views/Loading";
import  {getSystemConfig} from '@utils/sysconfiguration.js';
Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Index",
      meta: {
        title: "Interesting Mall",
        keepAlive: true,
        footer: true,
        auth: false,
        backgroundColor: "#fff"
      },
      component: Index
    },
    {
      path: "/customer/chat/:id",
      name: "CustomerService",
      meta: {
        title: "Chat with customer service",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/user/CustomerService.vue")
    },
    {
      path: "/category/:pid?",
      name: "GoodsClass",
      meta: {
        title: "Product category",
        keepAlive: true,
        footer: true,
        auth: true,
        backgroundColor: "#fff"
      },
      component: Category
    },
    {
      path: "/collection",
      name: "GoodsCollection",
      meta: {
        title: "Collection of goods",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/shop/GoodsCollection.vue")
    },
    {
      path: "/search",
      name: "GoodSearch",
      meta: {
        title: "Product search",
        keepAlive: true,
        backgroundColor: "#fff",
        auth: true
      },
      component: Search
    },
    {
      path: "/news_detail/:id",
      name: "NewsDetail",
      meta: {
        title: "News detail",
        keepAlive: true,
        backgroundColor: "#fff",
        auth: true
      },
      component: () => import("@views/shop/news/NewsDetail.vue")
    },
    {
      path: "/news_list",
      name: "NewsList",
      meta: {
        title: "News",
        keepAlive: true,
        backgroundColor: "#fff",
        auth: true
      },
      component: () => import("@views/shop/news/NewsList.vue")
    },
    {
      path: "/evaluate_list/:id",
      name: "EvaluateList",
      meta: {
        title: "Product Rating",
        keepAlive: true,
        auth: true
      },
      component: () => import("@views/shop/EvaluateList.vue")
    },
    {
      path: "/goods_evaluate/:id",
      name: "GoodsEvaluate",
      meta: {
        title: "Product reviews",
        keepAlive: true,
        auth: true
      },
      component: () => import("@views/shop/GoodsEvaluate.vue")
    },
    {
      path: "/promotion",
      name: "GoodsPromotion",
      meta: {
        title: "Sales item",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/shop/GoodsPromotion.vue")
    },
    {
      path: "/hot_new_goods/:type",
      name: "HotNewGoods",
      meta: {
        title: "Popular items",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/shop/HotNewGoods.vue")
    },
    {
      path: "/detail/:id",
      name: "GoodsCon",
      meta: {
        title: "Product details",
        keepAlive: false,
        auth: false
      },
      component: () => import("@views/shop/GoodsCon.vue")
    },
    {
      path: "/integral/detail/:id",
      name: "GoodsCon",
      meta: {
        title: "Product points details",
        keepAlive: false,
        auth: false
      },
      component: () => import("@views/shop/integral/detail.vue")
    },
    {
      path: "/cart",
      name: "ShoppingCart",
      meta: {
        title: "购物车",
        keepAlive: true,
        footer: true,
        auth: true
      },
      component: ShoppingCart
    },
    {
      path: "/integral",
      name: "integral",
      meta: {
        title: "Points redemption mall",
        footer: true,
        auth: false
      },
      component: IntegralShoppingCart
    },
    {
      path: "/goods_list",
      name: "GoodsList",
      meta: {
        title: "List of goods",
        keepAlive: true,
        auth: true
      },
      component: GoodsList
    },
    {
      path: "/vip_goods_list",
      name: "VipGoodsList",
      meta: {
        title: "VIP Goods List",
        keepAlive: true,
        footer: true,
        auth: false

      },
      component: () =>
          import("@views/shop/vip/GoodsList.vue")
    },
    {
      path: "/activity-area",
      name: "activityArea",
      meta: {
        title: "Activity Area",
        keepAlive: true,
        footer: true,
        auth: false,
        backgroundColor: "#fff"
      },
      component: activityArea
    },
    {
      path: "/lucky-award",
      name: "luckyAward",
      meta: {
        title: "Lucky Award",
        keepAlive: true,
        footer: true,
        auth: false,
        backgroundColor: "#fff"
      },
      component: LuckyAward
    },
    {
      path: "/turntable",
      name: "turntable",
      meta: {
        title: "Turntable",
        keepAlive: true,
        footer: true,
        auth: false,
        backgroundColor: "#fff"
      },
      component: Turntable
    },
    {
      path: "/club",
      name: "club",
      meta: {
        title: "IM Club",
        keepAlive: true,
        footer: true,
        auth: true,
        backgroundColor: "#fff"
      },
      component: Club
    },
    {
      path: "/club/lottery",
      name: "club_lottery",
      meta: {
        title: "IM Club Lottery",
        keepAlive: true,
        footer: true,
        auth: true,
        backgroundColor: "#fff"
      },
      component: ClubLottery
    },
    {
      path: "/register",
      name: "Register",
      meta: {
        title: "Register",
        keepAlive: true
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/Register.vue")
    },
    {
      path: "/RegisterService",
      name: "RegisterService ",
      meta: {
        title: "Register",
        keepAlive: true
      },
      component: () =>
          import(/* webpackChunkName: "login" */ "@views/user/RegisterService.vue")
    },
    {
      path: "/selectCode",
      name: "Register",
      meta: {
        title: "Register",
        keepAlive: true
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/selectCode.vue")
    },
    {
      path: "/change_password",
      name: "ChangePassword",
      meta: {
        title: "Change the password",
        keepAlive: true,
        backgroundColor: "#fff",
        auth: true
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/ChangePassword.vue")
    },
    {
      path: "/retrieve_password",
      name: "RetrievePassword",
      meta: {
        title: "Retrieve password",
        keepAlive: true
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/RetrievePassword.vue")
    },
    {
      path: "/retrieve_password2",
      name: "RetrievePassword2",
      meta: {
        title: "Retrieve password",
        keepAlive: true
      },
      component: () =>
          import(/* webpackChunkName: "login" */ "@views/user/RetrievePassword2.vue")
    },
    {
      path: "/login",
      name: "Login",
      meta: {
        title: "Login Interesting Mall",
        keepAlive: true
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/Login.vue")
    },
    {
      path: "/maintenancePage",
      name: "maintenancePage",
      meta: {
        title: "MaintenancePage",
        keepAlive: true,
        footer:false,
        home: false,
      },
      component: () =>
          import(/* webpackChunkName: "login" */ "@views/maintenance/maintenancePage.vue")
    },
    ...module,
    {
      path: "/auth/:url",
      name: "Loading",
      meta: {
        title: " Loading...",
        keepAlive: true
      },
      component: Loading
    },
    {
      path: "*",
      name: "NotDefined",
      meta: {
        title: "Not found",
        keepAlive: true,
        home: false,
        backgroundColor: "#F4F6FB"
      },
      component: NotDefined
    }
  ],
  scrollBehavior(to, from) {
    from.meta.scrollTop = window.scrollY;
    return { x: 0, y: to.meta.scrollTop || 0 };
  }
});

const { back, replace } = router;

router.back = function() {
  this.isBack = true;
  back.call(router);
};
router.replace = function(...args) {
  this.isReplace = true;
  replace.call(router, ...args);
};


router.beforeEach((to, form, next) => {

  const { title, backgroundColor, footer, home, auth } = to.meta;
  if (auth === true && !$store.state.app.token) {
    if (form.name === "Login" || form.name === "Index") return;
    return toLogin(false, to.fullPath);
  }
  document.title = title || process.env.VUE_APP_NAME || "Interesting Mall";
  //判断是否显示底部导航
  footer === true ? $store.commit("SHOW_FOOTER") : $store.commit("HIDE_FOOTER");

  //控制悬浮按钮是否显示
  home === false ? $store.commit("HIDE_HOME") : $store.commit("SHOW_HOME");

  $store.commit("BACKGROUND_COLOR", backgroundColor || "#F5F5F5");

  if (auth) {
    $store.dispatch("USERINFO").then(() => {
      next();
    });
  } else next();
});
// router.beforeEach((to, form, next) => {
//
//   if(to.name!='maintenancePage')
//   {
//     // console.log(to.meta);
//     getSystemConfig('routine_index_logo').then((res)=>{
//       if(res==="1")
//       {
//         // console.log(0);
//         next({path:'/maintenancePage'});
//       }
//       else
//       {
//         const { title, backgroundColor, footer, home, auth } = to.meta;
//         if (auth === true && !$store.state.app.token) {
//           // console.log(1);
//           if (form.name === "Login" || form.name === "Index") return;
//           return toLogin(false, to.fullPath);
//         }
//         // console.log(2);
//         document.title = title || process.env.VUE_APP_NAME || "Interesting Mall";
//         //判断是否显示底部导航
//         footer === true ? $store.commit("SHOW_FOOTER") : $store.commit("HIDE_FOOTER");
//
//         //控制悬浮按钮是否显示
//         home === false ? $store.commit("HIDE_HOME") : $store.commit("SHOW_HOME");
//
//         $store.commit("BACKGROUND_COLOR", backgroundColor || "#F5F5F5");
//         if (auth) {
//           $store.dispatch("USERINFO").then(() => {
//             // console.log(3)
//             next();
//           });
//         } else {
//           // console.log(4);
//           next();
//         }
//       }
//     });
//   }
//   else
//   {
//     getSystemConfig('routine_index_logo').then((res)=>{
//       if(res==='1')
//       {
//         document.title = process.env.VUE_APP_NAME || "Interesting Mall";
//         //判断是否显示底部导航
//         $store.commit("HIDE_FOOTER");
//         //控制悬浮按钮是否显示
//         $store.commit("HIDE_HOME");
//         // console.log(5);
//         next();
//       }
//       else {
//         next('/');
//       }
//     });
//   }
//
// });

export default router;
